import type { JSX } from "react";

import CloseIcon from "@mui/icons-material/Close";
import { Alert, AlertTitle, IconButton, Stack, SxProps, Tooltip, Typography } from "@mui/material";
import { FileError, FileRejection } from "react-dropzone";

export const getUserFriendlyErrorCode = (error: FileError) => {
  return error.code.replace(/-/g, " ").replace(/^\w/, (character) => character.toUpperCase());
};

const getUserFriendlyErrorMessage = (error: FileError) => {
  if (error.code === "file-invalid-type") {
    return error.message.replace(/\s*,\s*/g, ", ");
  }

  return error.message;
};

export function DropzoneErrorDisplay({
  file,
  index,
  errors,
  setDropRejectedFiles,
  dropRejectedFiles,
  sx,
}: {
  file: File;
  index: number;
  errors: FileError[];
  setDropRejectedFiles?: (files: FileRejection[]) => void;
  dropRejectedFiles: FileRejection[];
  sx?: SxProps;
}): JSX.Element {
  return (
    <Alert
      key={`${file.name}-${index}`}
      severity="error"
      sx={{ width: "100%", ...sx }}
      action={
        <Tooltip title="Remove invalid file">
          <IconButton
            onClick={() => setDropRejectedFiles?.(dropRejectedFiles.filter((_, i) => i !== index))}
          >
            <CloseIcon />
          </IconButton>
        </Tooltip>
      }
    >
      <AlertTitle>Error: {file.name}</AlertTitle>
      <Stack spacing={1}>
        {errors.map((error) => (
          <Typography variant="body2" key={error.code + error.message}>
            {getUserFriendlyErrorMessage(error)}
          </Typography>
        ))}
      </Stack>
    </Alert>
  );
}
